<template>
  <footer class="site-footer">
    <div class="container footer-inner">
      <span class="footer-brand">{{ appName }}</span>
      <span class="footer-dot" aria-hidden="true"></span>
      <a
        class="footer-link"
        href="https://beian.miit.gov.cn/#/Integrated/index"
        target="_blank"
        rel="noopener"
      >浙ICP备2022016385号-2</a>
    </div>
  </footer>
</template>

<script>
import { DR_APP_NAME } from "../../appName";

export default {
  name: "SiteFooter",
  data() {
    return { appName: DR_APP_NAME };
  }
};
</script>

<style scoped>
.site-footer {
  padding: 28px 0;
  background: var(--ink);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: rgba(255, 255, 255, 0.42);
  font-size: 13px;
}

.footer-brand {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 600;
}

.footer-dot {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.26);
}

.footer-link {
  color: inherit;
  transition: color 0.18s ease;
}

.footer-link:hover {
  color: rgba(255, 255, 255, 0.8);
}
</style>
